<div class="ild_bg" *ngIf="showLoading==true"></div>

<div class="admin_con">
    <div class="left">
        <div class="admin_logo">
            <img src="./assets/ra_admin_logo2.png" alt="">
        </div>
        <div class="admin_nav">
            <a href="javascript:void(0)" [ngClass]="{'active':currentPage=='trends'}" (click)="changePage('trends')">
                <span></span>
                <em>项目动态</em>
            </a>
            <a href="javascript:void(0)" (click)="noticeShowHandle()">
                <span><img src="./assets/ILD_admin_ic_xtgl.png" alt=""></span>
                <em>通知公告</em>
            </a>
            <a *ngIf="showNotice == true" (click)="changePage('noticeList')" href="javascript:void(0)"
                [ngClass]="{'active':currentPage=='noticeList'}">
                <span></span>
                <em class="indentation">历史通知</em>
            </a>
            <a *ngIf="showNotice == true" href="javascript:void(0)" [ngClass]="{'active':currentPage=='notice'}"
                (click)="changePage('notice')">
                <span></span>
                <em class="indentation">编辑添加</em>
            </a>

            <a href="javascript:void(0)" (click)="newsShowHandle()">
                <span><img src="./assets/ILD_admin_ic_xtgl.png" alt=""></span>
                <em>新闻资讯</em>
            </a>
            <a *ngIf="showNews == true" href="javascript:void(0)" [ngClass]="{'active':currentPage=='newsList'}"
                (click)="changePage('newsList')">
                <span></span>
                <em class="indentation">历史新闻</em>
            </a>
            <a *ngIf="showNews == true" href="javascript:void(0)" [ngClass]="{'active':currentPage=='news'}"
                (click)="changePage('news')">
                <span></span>
                <em class="indentation">编辑添加</em>
            </a>
            <a *ngIf="showNews == true" href="javascript:void(0)" [ngClass]="{'active':currentPage=='newsType'}"
                (click)="changePage('newsType')">
                <span></span>
                <em class="indentation">新闻类型</em>
            </a>
            <!-- <a href="javascript:void(0)" [ngClass]="{'active':currentPage=='statistic'}"
                (click)="changePage('statistic')">
                <span></span>
                <em>数据展示</em>
            </a> -->
            <a href="javascript:void(0)" [ngClass]="{'active':currentPage=='user'}" (click)="changePage('user')">
                <span></span>
                <em>用户管理</em>
            </a>
            <a href="javascript:void(0)" [ngClass]="{'active':currentPage=='review'}" (click)="changePage('review')">
                <span></span>
                <em>诊疗中心评审</em>
            </a>
        </div>
    </div>
    <div class="right">
        <div class="right_nav">
            <div>
            </div>
            <div class="head_img">
                <img src="./assets/ILD_admin_ic_name.png" alt="">
                <span>{{username}}</span>
                <a *ngIf="username!=undefined&&username.length>0" (click)="logout()">退出</a>
            </div>
        </div>


        <div class="right_con" *ngIf="currentPage == 'noticeList'">
            <div class="create_but">
                <button (click)="create()">创建</button>
            </div>
            <div class="list">
                <table>
                    <tr class="title">
                        <td>标题</td>
                        <td>内容</td>
                        <td>创建时间</td>
                        <td>更新时间</td>
                        <td>操作</td>
                    </tr>
                    <tr *ngFor="let notice of currentPageNotice">
                        <td>{{notice.titleShow}}</td>
                        <td>{{notice.contentShow}}</td>
                        <td>{{notice.create_time}}</td>
                        <td>{{notice.update_time}}</td>
                        <td colspan="2">
                            <a href="javascript:void(0)" class="edit-btn" (click)="edit(notice)">编辑</a>
                            <a href="javascript:void(0)" class="delete-btn"
                                (click)="deleteNotice(notice,'notice')">删除</a>
                        </td>
                    </tr>
                </table>
            </div>
            <!-- 分页 -->
            <div class="paging">

                <!-- <span *ngFor="let page of newsPages" [ngClass]="{'active':page['active']==true}" (click)="">{{page.page}}</span> -->
                <em (click)="goForward('notice')" *ngIf="noticeCurrentPage > 1">上一页</em>
                <em style="color: #e86d42;cursor:default;" *ngIf="noticeCurrentPage <= 1">上一页</em>
                <em (click)="goNext('notice')" *ngIf="noticeCurrentPage < maxPage">下一页</em>
                <em style="color: #a42419;cursor:default;" *ngIf="noticeCurrentPage >=maxPage">下一页</em>
            </div>
            <!-- 分页 end -->

        </div>
        <div class="right_con" *ngIf="currentPage == 'newsList'">
            <div class="create_but">
                <button (click)="createNews()">创建</button>
            </div>
            <div class="list">
                <table>
                    <tr class="title">
                        <td>分组</td>
                        <td>标题</td>
                        <td>内容</td>
                        <td>创建时间</td>
                        <td>更新时间</td>
                        <td>操作</td>
                    </tr>
                    <tr *ngFor="let news of currentPageNews">
                        <td>{{news.name}}</td>
                        <td>{{news.titleShow}}</td>
                        <td>{{news.contentShow}}</td>
                        <td>{{news.create_time}}</td>
                        <td>{{news.update_time}}</td>
                        <td colspan="2">
                            <a href="javascript:void(0)" class="edit-btn" (click)="editNews(news)">编辑</a>
                            <a href="javascript:void(0)" class="delete-btn" (click)="deleteNews(news)">删除</a>
                        </td>
                    </tr>
                </table>
            </div>


            <!-- 分页 -->
            <div class="paging">

                <!-- <span *ngFor="let page of newsPages" [ngClass]="{'active':page['active']==true}" (click)="">{{page.page}}</span> -->
                <em (click)="goForward('news')" *ngIf="newsCurrentPage > 1">上一页</em>
                <em style="color: #e86d42;cursor:default;" *ngIf="newsCurrentPage <= 1">上一页</em>
                <em (click)="goNext('news')" *ngIf="newsCurrentPage < maxPage">下一页</em>
                <em style="color: #a42419;cursor:default;" *ngIf="newsCurrentPage >=maxPage">下一页</em>
            </div>
            <!-- 分页 end -->
        </div>

        <div class="right_con" *ngIf="currentPage == 'newsType'">
            <div class="create_but">
                <button (click)="createNewsType()">创建</button>
            </div>
            <div class="list">
                <table>
                    <tr class="title">
                        <td>标题</td>
                        <td>操作</td>
                    </tr>
                    <tr *ngFor="let newsType of newsTypeList;let i=index">
                        <td>{{newsType.name}}</td>
                        <td colspan="2">
                            <a href="javascript:void(0)" class="edit-btn" (click)="editNewsType(newsType)">编辑</a>
                            <a href="javascript:void(0)" class="delete-btn" (click)="deleteNewsType(newsType)">删除</a>
                        </td>
                    </tr>
                </table>
            </div>
        </div>


        <div class="right_con" *ngIf="currentPage == 'statistic'">
            <div class="upload_download">
                <button class="upload_btn" (click)="changeOperate(1)">上传</button>
                <button class="download_btn" (click)="changeOperate(2)">下载</button>
            </div>
            <div class="list">
                <table>
                    <tr class="title">
                        <td>序号</td>
                        <td>组织</td>
                        <td>姓名</td>
                        <td>动作</td>
                        <td>对象名</td>
                        <td>时间</td>
                        <td *ngIf="statisticType == 1">操作</td>
                    </tr>
                    <tr *ngFor="let data of currentPageStatistic;let i = index">
                        <td>{{i+1}}</td>
                        <td>{{data.hospital}}</td>
                        <td>{{data.username}}</td>
                        <td style="color: green;" *ngIf="data.type == '上传'">{{data.type}}</td>
                        <td style="color: red;" *ngIf="data.type == '下载'">{{data.type}}</td>
                        <td>{{data.name}}</td>
                        <td>{{data.create_time}}</td>
                        <td *ngIf="data.type == '上传'"><button class="download_btn"
                                (click)="downLoad(data.url,data.name)">下载</button></td>
                    </tr>
                </table>
            </div>

            <!-- 分页 -->
            <div class="paging">

                <!-- <span *ngFor="let page of newsPages" [ngClass]="{'active':page['active']==true}" (click)="">{{page.page}}</span> -->
                <em (click)="goForward('statistic')" *ngIf="statisticCurrentPage > 1">上一页</em>
                <em style="color: #e86d42;cursor:default;" *ngIf="statisticCurrentPage <= 1">上一页</em>
                <em (click)="goNext('statistic')" *ngIf="statisticCurrentPage < maxPage">下一页</em>
                <em style="color: #a42419;cursor:default;" *ngIf="statisticCurrentPage >=maxPage">下一页</em>
            </div>
            <!-- 分页 end -->
        </div>


        <div class="right_con" *ngIf="currentPage == 'user'">

            <div class="upload_download">
                <button class="upload_btn" (click)="changeOperateUser(1)">用户管理</button>
                <button class="download_btn" (click)="changeOperateUser(2)">禁用记录</button>
            </div>

            <div class="list">
                <table>
                    <tr class="title">
                        <td>序号</td>
                        <td>组织</td>
                        <td>姓名</td>
                        <td>手机号</td>
                        <td *ngIf="userManagePage == 2">原因</td>
                        <td>注册时间</td>
                        <td *ngIf="userManagePage == 2">禁用时间</td>
                        <td *ngIf="userManagePage == 2">操作员</td>
                        <td>操作</td>
                    </tr>
                    <tr *ngFor="let data of currentPageUser;let i = index">
                        <td>{{i+1}}</td>
                        <td>{{data.hospital}}</td>
                        <td>{{data.username}}</td>
                        <td>{{data.mobile}}</td>
                        <td *ngIf="userManagePage == 2">{{data.reason}}</td>
                        <td>{{data.register_time}}</td>
                        <td *ngIf="userManagePage == 2">{{data.ban_time}}</td>
                        <td *ngIf="userManagePage == 2">{{data.operator}}</td>
                        <td>
                            <button class="download_btn" *ngIf="userManagePage == 1"
                                (click)="operateUser(data.id,2)">禁用</button>
                            <button class="upload_btn" *ngIf="userManagePage == 2"
                                (click)="operateUser(data.id,1)">恢复</button>
                        </td>
                    </tr>
                </table>
            </div>

            <!-- 分页 -->
            <div class="paging">

                <!-- <span *ngFor="let page of newsPages" [ngClass]="{'active':page['active']==true}" (click)="">{{page.page}}</span> -->
                <em (click)="goForward('user')" *ngIf="userCurrentPage > 1">上一页</em>
                <em style="color: #e86d42;cursor:default;" *ngIf="userCurrentPage <= 1">上一页</em>
                <em (click)="goNext('user')" *ngIf="userCurrentPage < maxPage">下一页</em>
                <em style="color: #a42419;cursor:default;" *ngIf="userCurrentPage >=maxPage">下一页</em>
            </div>
            <!-- 分页 end -->
        </div>

        <!-- 项目动态 -->
        <div class="dynamic" *ngIf="currentPage=='trends'">
            <div class="title">项目动态</div>
            <div class="img_con">
                <div class="img_list">

                    <div>
                        <span>第一张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs1['src'].length>0" [(ngModel)]="image1" (change)="imgsChange($event,1)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs1['src'].length > 0"
                                (click)="delete(1)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs1['src'].length == 0">
                            <img src="{{imgs1['srcThum']}}" alt="" *ngIf="imgs1['src'].length > 0">

                        </p>
                        <em>
                            <button *ngIf="imgs1['src'].length > 0 && imgs1['status']=='1'"
                                (click)="publish(imgs1,'2')">发布</button>
                            <button class="del" *ngIf="imgs1['src'].length > 0 && imgs1['status']=='2'"
                                (click)="publish(imgs1,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第二张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs2['src'].length>0" [(ngModel)]="image2" (change)="imgsChange($event,2)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs2['src'].length > 0"
                                (click)="delete(2)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs2['src'].length == 0">
                            <img src="{{imgs2['srcThum']}}" alt="" *ngIf="imgs2['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs2['src'].length > 0 && imgs2['status']=='1'"
                                (click)="publish(imgs2,'2')">发布</button>
                            <button class="del" *ngIf="imgs2['src'].length > 0 && imgs2['status']=='2'"
                                (click)="publish(imgs2,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第三张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs3['src'].length>0" [(ngModel)]="image3" (change)="imgsChange($event,3)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs3['src'].length > 0"
                                (click)="delete(3)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs3['src'].length == 0">
                            <img src="{{imgs3['srcThum']}}" alt="" *ngIf="imgs3['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs3['src'].length > 0 && imgs3['status']=='1'"
                                (click)="publish(imgs3,'2')">发布</button>
                            <button class="del" *ngIf="imgs3['src'].length > 0 && imgs3['status']=='2'"
                                (click)="publish(imgs3,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第四张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs4['src'].length>0" [(ngModel)]="image4" (change)="imgsChange($event,4)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs4['src'].length > 0"
                                (click)="delete(4)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs4['src'].length == 0">
                            <img src="{{imgs4['srcThum']}}" alt="" *ngIf="imgs4['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs4['src'].length > 0 && imgs4['status']=='1'"
                                (click)="publish(imgs4,'2')">发布</button>
                            <button class="del" *ngIf="imgs4['src'].length > 0 && imgs4['status']=='2'"
                                (click)="publish(imgs4,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第五张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs5['src'].length>0" [(ngModel)]="image5" (change)="imgsChange($event,5)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs5['src'].length > 0"
                                (click)="delete(5)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs5['src'].length == 0">
                            <img src="{{imgs5['srcThum']}}" alt="" *ngIf="imgs5['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs5['src'].length > 0 && imgs5['status']=='1'"
                                (click)="publish(imgs5,'2')">发布</button>
                            <button class="del" *ngIf="imgs5['src'].length > 0 && imgs5['status']=='2'"
                                (click)="publish(imgs5,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第六张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs6['src'].length>0" [(ngModel)]="image6" (change)="imgsChange($event,6)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs6['src'].length > 0"
                                (click)="delete(6)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs6['src'].length == 0">
                            <img src="{{imgs6['srcThum']}}" alt="" *ngIf="imgs6['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs6['src'].length > 0 && imgs6['status']=='1'"
                                (click)="publish(imgs6,'2')">发布</button>
                            <button class="del" *ngIf="imgs6['src'].length > 0 && imgs6['status']=='2'"
                                (click)="publish(imgs6,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第七张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs7['src'].length>0" [(ngModel)]="image7" (change)="imgsChange($event,7)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs7['src'].length > 0"
                                (click)="delete(7)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs7['src'].length == 0">
                            <img src="{{imgs7['srcThum']}}" alt="" *ngIf="imgs7['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs7['src'].length > 0 && imgs7['status']=='1'"
                                (click)="publish(imgs7,'2')">发布</button>
                            <button class="del" *ngIf="imgs7['src'].length > 0 && imgs7['status']=='2'"
                                (click)="publish(imgs7,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第八张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs8['src'].length>0" [(ngModel)]="image8" (change)="imgsChange($event,8)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs8['src'].length > 0"
                                (click)="delete(8)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs8['src'].length == 0">
                            <img src="{{imgs8['srcThum']}}" alt="" *ngIf="imgs8['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs8['src'].length > 0 && imgs8['status']=='1'"
                                (click)="publish(imgs8,'2')">发布</button>
                            <button class="del" *ngIf="imgs8['src'].length > 0 && imgs8['status']=='2'"
                                (click)="publish(imgs8,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第九张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs9['src'].length>0" [(ngModel)]="image9" (change)="imgsChange($event,9)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs9['src'].length > 0"
                                (click)="delete(9)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs9['src'].length == 0">
                            <img src="{{imgs9['srcThum']}}" alt="" *ngIf="imgs9['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs9['src'].length > 0 && imgs9['status']=='1'"
                                (click)="publish(imgs9,'2')">发布</button>
                            <button class="del" *ngIf="imgs9['src'].length > 0 && imgs9['status']=='2'"
                                (click)="publish(imgs9,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第十张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs10['src'].length>0" [(ngModel)]="image10"
                                (change)="imgsChange($event,10)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs10['src'].length > 0"
                                (click)="delete(10)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs10['src'].length == 0">
                            <img src="{{imgs10['srcThum']}}" alt="" *ngIf="imgs10['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs10['src'].length > 0 && imgs10['status']=='1'"
                                (click)="publish(imgs10,'2')">发布</button>
                            <button class="del" *ngIf="imgs10['src'].length > 0 && imgs10['status']=='2'"
                                (click)="publish(imgs10,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第十一张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs11['src'].length>0" [(ngModel)]="image11"
                                (change)="imgsChange($event,11)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs11['src'].length > 0"
                                (click)="delete(11)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs11['src'].length == 0">
                            <img src="{{imgs11['srcThum']}}" alt="" *ngIf="imgs11['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs11['src'].length > 0 && imgs11['status']=='1'"
                                (click)="publish(imgs11,'2')">发布</button>
                            <button class="del" *ngIf="imgs11['src'].length > 0 && imgs11['status']=='2'"
                                (click)="publish(imgs11,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第十二张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs12['src'].length>0" [(ngModel)]="image12"
                                (change)="imgsChange($event,12)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs12['src'].length > 0"
                                (click)="delete(12)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs12['src'].length == 0">
                            <img src="{{imgs12['srcThum']}}" alt="" *ngIf="imgs12['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs12['src'].length > 0 && imgs12['status']=='1'"
                                (click)="publish(imgs12,'2')">发布</button>
                            <button class="del" *ngIf="imgs12['src'].length > 0 && imgs12['status']=='2'"
                                (click)="publish(imgs12,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第十三张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs13['src'].length>0" [(ngModel)]="image13"
                                (change)="imgsChange($event,13)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs13['src'].length > 0"
                                (click)="delete(13)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs13['src'].length == 0">
                            <img src="{{imgs13['srcThum']}}" alt="" *ngIf="imgs13['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs13['src'].length > 0 && imgs13['status']=='1'"
                                (click)="publish(imgs13,'2')">发布</button>
                            <button class="del" *ngIf="imgs13['src'].length > 0 && imgs13['status']=='2'"
                                (click)="publish(imgs13,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第十四张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs14['src'].length>0" [(ngModel)]="image14"
                                (change)="imgsChange($event,14)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs14['src'].length > 0"
                                (click)="delete(14)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs14['src'].length == 0">
                            <img src="{{imgs14['srcThum']}}" alt="" *ngIf="imgs14['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs14['src'].length > 0 && imgs14['status']=='1'"
                                (click)="publish(imgs14,'2')">发布</button>
                            <button class="del" *ngIf="imgs14['src'].length > 0 && imgs14['status']=='2'"
                                (click)="publish(imgs14,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第十五张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs15['src'].length>0" [(ngModel)]="image15"
                                (change)="imgsChange($event,15)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs15['src'].length > 0"
                                (click)="delete(15)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs15['src'].length == 0">
                            <img src="{{imgs15['srcThum']}}" alt="" *ngIf="imgs15['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs15['src'].length > 0 && imgs15['status']=='1'"
                                (click)="publish(imgs15,'2')">发布</button>
                            <button class="del" *ngIf="imgs15['src'].length > 0 && imgs15['status']=='2'"
                                (click)="publish(imgs15,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第十六张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs16['src'].length>0" [(ngModel)]="image16"
                                (change)="imgsChange($event,16)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs16['src'].length > 0"
                                (click)="delete(16)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs16['src'].length == 0">
                            <img src="{{imgs16['srcThum']}}" alt="" *ngIf="imgs16['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs16['src'].length > 0 && imgs16['status']=='1'"
                                (click)="publish(imgs16,'2')">发布</button>
                            <button class="del" *ngIf="imgs16['src'].length > 0 && imgs16['status']=='2'"
                                (click)="publish(imgs16,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第十七张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs17['src'].length>0" [(ngModel)]="image17"
                                (change)="imgsChange($event,17)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs17['src'].length > 0"
                                (click)="delete(17)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs17['src'].length == 0">
                            <img src="{{imgs5['srcThum']}}" alt="" *ngIf="imgs17['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs17['src'].length > 0 && imgs17['status']=='1'"
                                (click)="publish(imgs17,'2')">发布</button>
                            <button class="del" *ngIf="imgs17['src'].length > 0 && imgs17['status']=='2'"
                                (click)="publish(imgs17,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第十八张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs18['src'].length>0" [(ngModel)]="image18"
                                (change)="imgsChange($event,18)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs18['src'].length > 0"
                                (click)="delete(18)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs18['src'].length == 0">
                            <img src="{{imgs18['srcThum']}}" alt="" *ngIf="imgs18['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs18['src'].length > 0 && imgs18['status']=='1'"
                                (click)="publish(imgs18,'2')">发布</button>
                            <button class="del" *ngIf="imgs18['src'].length > 0 && imgs18['status']=='2'"
                                (click)="publish(imgs18,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第十九张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs19['src'].length>0" [(ngModel)]="image19"
                                (change)="imgsChange($event,19)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs19['src'].length > 0"
                                (click)="delete(19)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs19['src'].length == 0">
                            <img src="{{imgs19['srcThum']}}" alt="" *ngIf="imgs19['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs19['src'].length > 0 && imgs19['status']=='1'"
                                (click)="publish(imgs19,'2')">发布</button>
                            <button class="del" *ngIf="imgs19['src'].length > 0 && imgs19['status']=='2'"
                                (click)="publish(imgs19,'1')">取消发布</button>
                        </em>
                    </div>

                    <div>
                        <span>第二十张</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="imgs20['src'].length>0" [(ngModel)]="image20"
                                (change)="imgsChange($event,20)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="imgs20['src'].length > 0"
                                (click)="delete(20)">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="imgs20['src'].length == 0">
                            <img src="{{imgs20['srcThum']}}" alt="" *ngIf="imgs20['src'].length > 0">
                        </p>
                        <em>
                            <button *ngIf="imgs20['src'].length > 0 && imgs20['status']=='1'"
                                (click)="publish(imgs20,'2')">发布</button>
                            <button class="del" *ngIf="imgs20['src'].length > 0 && imgs20['status']=='2'"
                                (click)="publish(imgs20,'1')">取消发布</button>
                        </em>
                    </div>

                </div>
                <button (click)="submit()">保存</button>
            </div>
        </div>

        <!-- 通知公告编辑 -->
        <div class="dynamic" *ngIf="currentPage=='notice'">
            <div class="title">通知公告编辑</div>
            <div class="img_con">
                <div class="edit_con">
                    <textarea class="noticeTitle" name="" id="" cols="30" rows="10" placeholder="请输入"
                        [(ngModel)]="noticeTitle" (change)="changeNoticeTitle()"></textarea>
                    <!-- <input type="text" placeholder="请输入" [(ngModel)]="noticeTitle" (change)="changeNoticeTitle()"> -->
                    <div class="edit">
                        <div id="div1">
                            <p [innerHTML]="noticeContent"></p>
                        </div>
                    </div>
                </div>
                <button (click)="save('notice')">保存</button>
            </div>
        </div>

        <div class="dynamic" *ngIf="currentPage=='newsTypeEdit'">
            <div class="title">新闻类型编辑</div>
            <div class="img_con">
                <div class="edit_con">
                    <textarea class="noticeTitle" name="" id="" cols="30" rows="10" placeholder="请输入"
                        [(ngModel)]="newsTypeName" (change)="changeNewsType()"></textarea>
                </div>
                <button (click)="save('newsType')">保存</button>
            </div>
        </div>

        <!-- 新闻资讯编辑 -->
        <div class="dynamic" *ngIf="currentPage=='news'">
            <div class="title">新闻资讯编辑</div>
            <div class="img_con">
                <div class="edit_con">
                    <select name="" id="" [(ngModel)]="newsTypeId" (change)="newsTypeChange()">
                        <option value="" checked disabled>请选择文章类型</option>
                        <option *ngFor="let newsType of newsTypeList" value="{{newsType.id}}">
                            {{newsType.name}}</option>
                    </select>
                    <textarea class="noticeTitle" name="" id="" cols="30" rows="10" placeholder="请输入"
                        [(ngModel)]="newsTitle" (change)="changeNewsTitle()"></textarea>
                    <div class="edit">
                        <div id="div1">
                            <p [innerHTML]="newsContent"></p>
                        </div>
                    </div>
                </div>
                <div class="img_list edit_img">
                    <div>
                        <span>封面上传</span>
                        <p>
                            <input type="file" accept="image/gif,image/jpeg,image/jpg,image/png,image"
                                [disabled]="newsCoverSrc.length>0" [(ngModel)]="newsCover"
                                (change)="newsImgsChange($event)">
                            <img class="del" src="./assets/ILD_admin_ic_del.png" alt="" *ngIf="newsCoverSrc.length > 0"
                                (click)="deleteNewsImg()">
                            <img src="./assets/ILD_admin_xwzxbj_tjzp.png" alt="" *ngIf="newsCoverSrc.length == 0">
                            <img src="{{newsCoverSrc}}" alt="" *ngIf="newsCoverSrc.length > 0">
                        </p>
                    </div>
                </div>
                <button (click)="save('news')">保存</button>
            </div>
        </div>

        <!-- 注册数据展示 -->

        <!-- 用户自评 列表 -->
        <div class="right_con" *ngIf="currentPage == 'review'">
            <div class="create_but dFlex row">
                <div class="col-sm-1 textRight p-0">医院名称：</div>
                <div class="col-sm-4"><input class="form-control" type="text" placeholder="请输入名称" disabled
                        [(ngModel)]="hospitalName"></div>
                <div class="col-sm-1 textRight">状态：</div>
                <div class="col-sm-3">
                    <select name="" id="" class="form-control" [(ngModel)]="status">
                        <option value="0" disabled>请选择</option>
                        <option value="">全部</option>
                        <option value="001">审核中</option>
                        <option value="002">通过</option>
                        <option value="003">未通过</option>
                    </select>
                </div>
                <div class="col-sm-3">
                    <button (click)="search()" class="bge1130c">搜索</button>
                </div>
            </div>
            <div class="list">
                <table>
                    <tr class="title">
                        <td>序号</td>
                        <td>医院</td>
                        <td>提交时间</td>
                        <td>提交人</td>
                        <td>联系方式</td>
                        <td>状态</td>
                        <td>自评结果</td>
                        <td>在线表格</td>
                    </tr>
                    <tr *ngFor="let table of tableList;index as i">
                        <td>{{i+1}}</td>
                        <td>{{table.organ}}</td>
                        <td>{{table.inspect_time}}</td>
                        <td>{{table.self_evaluator_username}}</td>
                        <td>{{table.other_evaluator_mobile}}</td>
                        <td>{{table.checkStatus}}</td>
                        <td>
                            <p>分数：{{table.selfScoreSum}}</p>
                            <p>{{table.selfUpdateTime}}</p>
                            <a class="edit mr0" (click)="viewDetail(table,'question')">查看</a>
                        </td>
                        <td>
                            <p>分数：{{table.otherScoreSum}}</p>
                            <p>{{table.otherUpdateTime}}</p>
                            <a class="edit mr0" (click)="viewDetail(table,'onlineTables')">查看</a>
                        </td>
                    </tr>
                </table>
            </div>
            <!-- 分页 -->
            <div class="paging">
                <em (click)="pageChange('start')" style="color: #a42419;cursor:default;">首页</em>
                <em (click)="pageChange('after')">上一页</em>
                <!-- <span class="active">1</span>
                <span>2</span>
                <span>3</span>
                <span>4</span> -->
                <em (click)="pageChange('next')">下一页</em>
                <em (click)="pageChange('end')" style="color: #a42419;cursor:default;">尾页</em>
            </div>
            <!-- 分页 end -->
        </div>

        <!-- 用户自评结果 -->

        <div class="right_con" *ngIf="currentPage == 'question'">
            <div class="question admin-question">
                <div class="back">
                    <div>
                        <div>医院：{{hospitalItem}}</div>
                        <div>提交时间：{{inspectTime}}</div>
                        <div>提交人：{{userName}}</div>
                        <div>联系方式：{{mobile}}</div>
                        <div>状态：<span class="fontBold">{{checkStatusItem}}</span></div>
                        <div>自评结果：<span class="fontBold">{{scoreItem}}</span></div>
                    </div>
                    <a class="back-btn" (click)="changePage('review')">返回</a>
                </div>
                <div class="title-1">
                    中心自评
                </div>
                <div class="title-3 dFlex">
                    <p class="flex1">基本条件及资质（5 分）</p> <span>得分{{scoreReview.scoreSum1}}分</span>
                </div>
                <div class="qlist">
                    <p>三级综合医院， 医院设立独立风湿免疫科 <span>（5分<em class="colorf08200">/得分{{scoreReview.score1}}分</em>）</span></p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item1 == '001'}">是</span>
                        <span [ngClass]="{'active':review.item1 == '002'}">否</span>
                    </div>
                </div>
                <div class="title-3 dFlex">
                    <p class="flex1">组织管理要求（20 分）</p> <span>得分{{scoreReview.scoreSum2}}分</span>
                </div>
                <div class="qlist">
                    <p>风湿免疫科中， 主治医师及以上医师占比达到 60%<span>（5分<em class="colorf08200">/得分{{scoreReview.score2}}分</em>）</span>
                    </p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item2 == '001'}">是</span>
                        <span [ngClass]="{'active':review.item2 == '002'}">否</span>
                    </div>
                </div>
                <div class="qlist nodFlex">
                    <div class="dFlex">
                        <p class="flex1">拥有至少一名风湿免疫学术带头人：<span>（5分<em
                                    class="colorf08200">/得分{{scoreReview.score3}}分</em>）</span>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item3 == '001'}">是</span>
                            <span [ngClass]="{'active':review.item3 == '002'}">否</span>
                        </div>
                    </div>
                    <div class="dFlex">
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="radio" name="a" value="001" [(ngModel)]="review.item4"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">国家级学会委员</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="radio" name="a" value="002" [(ngModel)]="review.item4"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">省级学会主委</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="radio" name="a" value="003" [(ngModel)]="review.item4"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">省级学会常委</div>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="qlist">
                    <p>风湿免疫科有至少 2 名能进行类风湿关节炎（RA）诊疗与研究的专业医师，具备 RA 规范化诊断和管理能力，有疾病评估团队、包括负责指导患者评估的护士至少1名<span>（5分<em
                                class="colorf08200">/得分{{scoreReview.score4}}分</em>）</span></p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item5 == '001'}">是</span>
                        <span [ngClass]="{'active':review.item5 == '002'}">否</span>
                    </div>
                </div>
                <div class="qlist">
                    <p>是否有能力开展针对 RA 患者的 MDT 跨学科合作诊疗，MDT 科室资源应包括骨科、放射科、呼吸科、心内科、内分泌科等，能够对 RA
                        器官受累患者进行跨学科诊治、会诊和转诊等<span>（5分<em class="colorf08200">/得分{{scoreReview.score5}}分</em>）</span></p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item6 == '001'}">是</span>
                        <span [ngClass]="{'active':review.item6 == '002'}">否</span>
                    </div>
                </div>
                <div class="title-3 dFlex">
                    <p class="flex1">建设及服务要求（ 35 分）</p> <span>得分{{scoreReview.scoreSum3}}分</span>
                </div>
                <div class="qlist nodFlex">
                    <p>使用国家风湿病数据中心（CRDC）作为随访管理平台，建立符合标准的类风湿关节炎患者信息登记和统计随访，常规进行类风湿关节炎患者诊疗、用药情况 登记：<span>（10分<em
                                class="colorf08200">/得分{{scoreReview.score6}}分</em>）</span></p>
                    <div class="dFlex">
                        <label class="radio-button">
                            <input type="radio" name="b" value="001" [(ngModel)]="review.item7"
                                (ngModelChange)="itemChange()" disabled>
                            <span class="custom-radio-button"></span>
                            <div class="label">总计录入 2500 名及以上患者</div>
                        </label>
                    </div>
                    <div class="dFlex">
                        <label class="radio-button">
                            <input type="radio" name="b" value="002" [(ngModel)]="review.item7"
                                (ngModelChange)="itemChange()" disabled>
                            <span class="custom-radio-button"></span>
                            <div class="label">总计录入 2000 名患者</div>
                        </label>
                    </div>
                    <div class="dFlex">
                        <label class="radio-button">
                            <input type="radio" name="b" value="003" [(ngModel)]="review.item7"
                                (ngModelChange)="itemChange()" disabled>
                            <span class="custom-radio-button"></span>
                            <div class="label">总计录入 1500 名患者</div>
                        </label>
                    </div>
                    <div class="dFlex">
                        <label class="radio-button">
                            <input type="radio" name="b" value="004" [(ngModel)]="review.item7"
                                (ngModelChange)="itemChange()" disabled>
                            <span class="custom-radio-button"></span>
                            <div class="label">总计录入 1000 名以下患者</div>
                        </label>
                    </div>
                </div>
                <div class="qlist">
                    <p>能进行炎性指标检查，如红细胞沉降率、 C 反应蛋白或超敏C反应蛋白等<span>（1分<em
                                class="colorf08200">/得分{{scoreReview.score7}}分</em>）</span>
                    </p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item8 == '001'}" (click)="changeItem('item8','001')">是</span>
                        <span [ngClass]="{'active':review.item8 == '002'}" (click)="changeItem('item8','002')">否</span>
                    </div>
                </div>
                <div class="qlist">
                    <p>能进行免疫学相关检查，包括：类风湿因子（RF）和 抗瓜氨酸蛋白抗体(ACPA)<span>（5分<em
                                class="colorf08200">/得分{{scoreReview.score8}}分</em>）</span>
                    </p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item9 == '001'}" (click)="changeItem('item9','001')">是</span>
                        <span [ngClass]="{'active':review.item9 == '002'}" (click)="changeItem('item9','002')">否</span>
                    </div>
                </div>
                <div class="qlist">
                    <p>医院具备关节X线、胸部高分辨CT等影像学检查能力<span>（5分<em class="colorf08200">/得分{{scoreReview.score9}}分</em>）</span>
                    </p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item10 == '001'}"
                            (click)="changeItem('item10','001')">是</span>
                        <span [ngClass]="{'active':review.item10 == '002'}"
                            (click)="changeItem('item10','002')">否</span>
                    </div>
                </div>
                <div class="qlist">
                    <p>医院具备关节超声、MRI等影像学检查能力<span>（3分<em class="colorf08200">/得分{{scoreReview.score10}}分</em>）</span></p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item11 == '001'}"
                            (click)="changeItem('item11','001')">是</span>
                        <span [ngClass]="{'active':review.item11 == '002'}"
                            (click)="changeItem('item11','002')">否</span>
                    </div>
                </div>
                <div class="qlist nodFlex">
                    <div class="dFlex">
                        <p class="flex1">能够可及到《中国类风湿关节炎诊断与治疗指南（2024版）》中提到的常规治疗药物 ，以及在中国获批的创新生物制剂：<span>（8分<em
                                    class="colorf08200">/得分{{scoreReview.scoreSum6}}分</em>）</span></p>
                        <!-- <div class="segment">
                              <span [ngClass]="{'active':review.item57 == '001'}" (click)="changeItem('item57','001')">是</span>
                              <span [ngClass]="{'active':review.item57 == '002'}" (click)="changeItem('item57','002')">否</span>
                            </div> -->
                    </div>

                    <div class="pl20 dFlex">
                        <p class="flex1">改善病情的抗风湿药<span>（3分<em
                                    class="colorf08200">/得分{{scoreReview.scoreSum4}}分</em>）</span></p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item12 == '001'}"
                                (click)="changeItem('item12','001')">是</span>
                            <span [ngClass]="{'active':review.item12 == '002'}"
                                (click)="changeItem('item12','002')">否</span>
                        </div>
                    </div>

                    <div class="pl40 dFlex" *ngIf="review.item12 == '001'">
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c1" value="001" [(ngModel)]="review.item14" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">甲氨蝶呤</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c2" value="001" [(ngModel)]="review.item15" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">来氟米特</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c3" value="001" [(ngModel)]="review.item16" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">柳氮磺吡啶</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c4" value="001" [(ngModel)]="review.item17" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">羟氯喹</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c5" value="001" [(ngModel)]="review.item18" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">艾拉莫德</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c6" value="001" [(ngModel)]="review.item19" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">雷公藤多苷</div>
                            </label>
                        </div>
                    </div>

                    <div class="pl20 dFlex">
                        <p class="flex1">非甾体类抗炎药<span>（1分<em
                                    class="colorf08200">/得分{{scoreReview.score11}}分</em>）</span></p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item20 == '001'}"
                                (click)="changeItem('item20','001')">是</span>
                            <span [ngClass]="{'active':review.item20 == '002'}"
                                (click)="changeItem('item20','002')">否</span>
                        </div>
                    </div>

                    <div class="pl20 dFlex">
                        <p class="flex1">糖皮质激素<span>（1分<em class="colorf08200">/得分{{scoreReview.score12}}分</em>）</span>
                        </p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item21 == '001'}"
                                (click)="changeItem('item21','001')">是</span>
                            <span [ngClass]="{'active':review.item21 == '002'}"
                                (click)="changeItem('item21','002')">否</span>
                        </div>
                    </div>

                    <div class="pl20 dFlex">
                        <p class="flex1">生物制剂及靶向药物<span>（3分<em
                                    class="colorf08200">/得分{{scoreReview.scoreSum5}}分</em>）</span></p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item22 == '001'}"
                                (click)="changeItem('item22','001')">是</span>
                            <span [ngClass]="{'active':review.item22 == '002'}"
                                (click)="changeItem('item22','002')">否</span>
                        </div>
                    </div>

                    <div class="pl40 dFlex" *ngIf="review.item22 == '001'">
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c1" value="001" [(ngModel)]="review.item23" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">TNF-α抑制剂</div>
                            </label>
                        </div>
                        <!-- <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c2" value="001" [(ngModel)]="review.item24" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">TNF-α受体融合蛋白</div>
                            </label>
                        </div> -->
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c3" value="001" [(ngModel)]="review.item25" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">JAK抑制剂</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c4" value="001" [(ngModel)]="review.item26" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">抗人IL-6受体单抗</div>
                            </label>
                        </div>

                    </div>

                </div>

                <div class="qlist">
                    <p>常规组织患者宣教活动并进行随访提醒<span>（3分<em class="colorf08200">/得分{{scoreReview.score13}}分</em>）</span></p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item27 == '001'}"
                            (click)="changeItem('item27','001')">是</span>
                        <span [ngClass]="{'active':review.item27 == '002'}"
                            (click)="changeItem('item27','002')">否</span>
                    </div>
                </div>

                <div class="title-3 dFlex">
                    <p class="flex1">规范诊疗要 求（8 分）</p> <span>得分{{specialScore}}分</span>
                </div>

                <div class="qlist">
                    <p>患者随访率，6个月随访率≥60% <span>（6分<em class="colorf08200">/得分{{specialScore1}}分</em>）</span> <span
                            class="score">
                            {{item1Special}}
                            / {{item1SumSpecial}} = {{rate1}}%</span>
                    </p>
                </div>
                <div class="qlist">
                    <p>患者随访率，12个月随访率≥60% <span>（9分<em class="colorf08200">/得分{{specialScore2}}分</em>）</span><span
                            class="score">
                            {{item2Special}}
                            / {{item2SumSpecial}} = {{rate2}}%</span>
                    </p>
                </div>
                <div class="qlist">
                    <p>患者随访率，≥ 12个月随访率≥30%<span>（10分<em class="colorf08200">/得分{{specialScore3}}分</em>）</span><span
                            class="score">
                            {{item3Special}}
                            / {{item3SumSpecial}} = {{rate3}}%</span></p>
                </div>
                <div class="qlist">
                    <p>每名患者每年至少随访2次的比例达到60%<span>（2分<em class="colorf08200">/得分{{specialScore4}}分</em>）</span><span
                            class="score">
                            {{item4Special}}
                            / {{item3SumSpecial}} = {{rate4}}%</span></p>
                </div>
                <div class="qlist">
                    <p>常规结合 1987年ACR RA分类标准和2010 ACR/EULAR RA分类标准为依据，进行诊断的患者比例达到 95%<span>（2分<em
                                class="colorf08200">/得分{{specialScore5}}分</em>）</span></p>
                </div>
                <div class="qlist">
                    <p>治疗6个月后达到临床缓解标准的患者比例 ≥50%；１年后达到临床缓解标准的患者比例 ≥60%<span>（8分<em
                                class="colorf08200">/得分{{specialScore6}}分</em>）</span>
                        <span class="score"> 六个月：
                            {{item6_5Special}}
                            / {{item1Special}} = {{rate6_1}}%</span> <span class="score"> 一年：
                            {{item6_6Special}}
                            / {{item2Special}} = {{rate6_2}}%</span>
                    </p>
                </div>
                <div class="qlist">
                    <p>筛查评估类风湿关节炎重要合并症和重要器官损害情况的患者比例达到 80%<span>（3分<em
                                class="colorf08200">/得分{{specialScore7}}分</em>）</span><span class="score">
                            {{item7Special}}
                            / {{itemSumSpecial}} = {{rate7}}%</span>
                    </p>
                </div>

                <div class="title-3 mt20 bgnone mb30 textRight">基本项目得分 {{baseScore}} 分</div>
                <div class="title-3 dFlex">
                    <p class="flex1">加分项目（50 分）</p><span>得分{{scoreReview.scoreSum9}}分</span>
                </div>
                <div class="qlist">
                    <p>具备 RA 患者临床生物样本库且正在使用该生物样本库进行患者样本收集<span>（10分<em
                                class="colorf08200">/得分{{scoreReview.score14}}分</em>）</span>
                    </p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item28 == '001'}"
                            (click)="changeItem('item28','001')">是</span>
                        <span [ngClass]="{'active':review.item28 == '002'}"
                            (click)="changeItem('item28','002')">否</span>
                    </div>
                </div>
                <div class="qlist">
                    <p>CRDC 自身抗体检测室间质评为“优秀”的单位<span>（5分<em class="colorf08200">/得分{{scoreReview.score15}}分</em>）</span>
                    </p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item29 == '001'}"
                            (click)="changeItem('item29','001')">是</span>
                        <span [ngClass]="{'active':review.item29 == '002'}"
                            (click)="changeItem('item29','002')">否</span>
                    </div>
                </div>
                <div class="qlist nodFlex">
                    <div class="dFlex">
                        <p class="flex1">为地市级及以上临研中心：<span>（5分<em
                                    class="colorf08200">/得分{{scoreReview.score16}}分</em>）</span></p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item30 == '001'}"
                                (click)="changeItem('item30','001')">是</span>
                            <span [ngClass]="{'active':review.item30 == '002'}"
                                (click)="changeItem('item30','002')">否</span>
                        </div>
                    </div>
                    <div class="dFlex" *ngIf="review.item30 == '001'">
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="radio" name="d" value="001" [(ngModel)]="review.item31"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">省级及以上</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="radio" name="d" value="002" [(ngModel)]="review.item31"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">地市级</div>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="qlist nodFlex">
                    <div class="dFlex">
                        <p class="flex1">为地市级及以上质控中心：<span>（5分<em
                                    class="colorf08200">/得分{{scoreReview.score17}}分</em>）</span></p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item33 == '001'}"
                                (click)="changeItem('item33','001')">是</span>
                            <span [ngClass]="{'active':review.item33 == '002'}"
                                (click)="changeItem('item33','002')">否</span>
                        </div>
                    </div>
                    <div class="dFlex" *ngIf="review.item33 == '001'">
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="radio" name="e" value="001" [(ngModel)]="review.item34"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">省级及以上</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="radio" name="e" value="002" [(ngModel)]="review.item34"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">地市级</div>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="qlist nodFlex">
                    <div class="dFlex">
                        <p class="flex1">积极开展类风湿关节炎相关教育培训工作<span>（8分<em
                                    class="colorf08200">/得分{{scoreReview.score18}}分</em>）</span>
                        </p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item35 == '001'}"
                                (click)="changeItem('item35','001')">是</span>
                            <span [ngClass]="{'active':review.item35 == '002'}"
                                (click)="changeItem('item35','002')">否</span>
                        </div>
                    </div>
                    <div *ngIf="review.item35 == '001'">
                        <div class="dFlex">
                            <label class="radio-button">
                                <input type="checkbox" disabled name="f" value="001" [(ngModel)]="review.item36"
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">开展国家级风湿免疫病继续医学教育项目</div>
                            </label>
                        </div>
                        <div *ngIf="review.item36 == '001' || review.item36 == '1'">
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item37"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item38"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item39"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                        </div>

                        <div class="dFlex">
                            <label class="radio-button">
                                <input type="checkbox" disabled name="f" value="001" [(ngModel)]="review.item40"
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">院内设有针对风湿免疫科医师和 MDT 科室医师的类风湿关节炎诊疗常规培训 活动</div>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="qlist nodFlex">
                    <div class="dFlex">
                        <p class="flex1">带动地市级单位风湿免疫科科室发展和人员培养 <span>（7分<em
                                    class="colorf08200">/得分{{scoreReview.score19}}分</em>）</span>
                        </p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item41 == '001'}"
                                (click)="changeItem('item41','001')">是</span>
                            <span [ngClass]="{'active':review.item41 == '002'}"
                                (click)="changeItem('item41','002')">否</span>
                        </div>
                    </div>

                    <div *ngIf="review.item41 == '001'">
                        <div class="dFlex">
                            <label class="radio-button">
                                <input type="checkbox" disabled name="g" value="001" [(ngModel)]="review.item42"
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">到地市医院开展学术会议、教学查房活动</div>
                            </label>
                        </div>
                        <div *ngIf="review.item42 == '001' || review.item42 == '1'">
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item43"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item44"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                        </div>
                        <div class="dFlex">
                            <label class="radio-button">
                                <input type="checkbox" disabled name="g" value="001" [(ngModel)]="review.item45"
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">接收地市级以上医院至本院进修</div>
                            </label>
                        </div>
                        <div *ngIf="review.item45 == '001' || review.item45 == '1'">
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item46"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item47"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item48"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                        </div>
                        <div class="dFlex">
                            <label class="radio-button">
                                <input type="checkbox" disabled name="g" value="001" [(ngModel)]="review.item49"
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">参与地市级医院的疑难重症病例的远程会诊与讨论</div>
                            </label>
                        </div>
                        <div *ngIf="review.item49 == '001' || review.item49 == '1'">
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item50"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item51"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                        </div>
                    </div>

                </div>
                <div class="qlist nodFlex">
                    <div class="dFlex">
                        <p class="flex1">具有良好的科研能力，近3年以第一或通讯作者单位发表（含接收）类风湿关节炎领域原创论文 ，按照当年 JCR 分区评分： <span>（5分<em
                                    class="colorf08200">/得分{{scoreReview.scoreSum7}}分</em>）</span></p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item52 == '001'}"
                                (click)="changeItem('item52','001')">是</span>
                            <span [ngClass]="{'active':review.item52 == '002'}"
                                (click)="changeItem('item52','002')">否</span>
                        </div>
                    </div>
                    <!-- <div *ngIf="review.item48 == '001'">
                        <p>近 3 年以第一或通讯作者单位发表（含接收）类风湿关节炎领域原创论文，按照当年JCR 分区评分：</p>
                    </div> -->
                    <div class="dFlex" *ngIf="review.item52 == '001'">
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" disabled name="h" value="001" [(ngModel)]="review.item53"
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">Q1</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" disabled name="h" value="001" [(ngModel)]="review.item54"
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">Q2</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" disabled name="h" value="001" [(ngModel)]="review.item55"
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">Q3</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" disabled name="h" value="001" [(ngModel)]="review.item56"
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">Q4</div>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="qlist nodFlex">
                    <div class="dFlex">
                        <p class="flex1">在 Rheumatology and Immunology Research 期刊上发表（含接收）类风湿关节炎 相关文章：<span>（5分<em
                                    class="colorf08200">/得分{{scoreReview.scoreSum8}}分</em>）</span></p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item57 == '001'}"
                                (click)="changeItem('item57','001')">是</span>
                            <span [ngClass]="{'active':review.item57 == '002'}"
                                (click)="changeItem('item57','002')">否</span>
                        </div>
                    </div>
                    <div class="dFlex" *ngIf="review.item57 == '001'">
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" disabled name="i" value="001" [(ngModel)]="review.item58"
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">Original article</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" disabled name="i" value="001" [(ngModel)]="review.item59"
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">Review</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" disabled name="i" value="001" [(ngModel)]="review.item60"
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">"Letters to the Editor" or "image"</div>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="title-3 mt20 bgnone textRight">您的自评总得分 {{scoreSum}} 分</div>
            </div>
        </div>

        <!-- 在线表格 -->
        <div class="right_con" *ngIf="currentPage == 'onlineTables'">
            <div class="question admin-question">
                <div class="back">
                    <div>
                        <div>医院：{{hospitalItem}}</div>
                        <div>提交时间：{{inspectTime}}</div>
                        <div>提交人：{{userName}}</div>
                        <div>联系方式：{{mobile}}</div>
                        <div>状态：<span class="fontBold">{{checkStatusItem}}</span></div>
                        <div>在线表格：<span class="fontBold">{{scoreItem}}</span></div>
                    </div>
                    <a class="back-btn" (click)="changePage('review')">返回</a>
                </div>
                <div class="title-1 findings-audit">
                    在线表格
                    <img src="./assets/adopt.png" alt="" *ngIf="checkStatus == '002'">
                    <img src="./assets/not-passed.png" alt="" *ngIf="checkStatus == '003'">
                </div>
                <div class="title-3 dFlex">
                    <p class="flex1">入组申请函</p>
                </div>
                <div class="qlist">
                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img20"
                            [(ngModel)]="image20" (change)="imgsChange($event,'img20')">
                        <img class="up_img" src="{{img.src}}" alt="" (click)="bigImgShow(img.src)"
                            *ngFor="let img of img20">
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img1')"> -->
                    </div>
                </div>


                <div class="title-3 dFlex">
                    <p class="flex1">基本条件及资质（5 分）</p><span>得分{{scoreReview.scoreSum1}}分</span>
                </div>
                <div class="qlist">
                    <p>三级综合医院， 医院设立独立风湿免疫科<span>（5分<em class="colorf08200">/得分{{scoreReview.score1}}分</em>）</span></p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item1 == '001'}" (click)="changeItem('item1','001')">是</span>
                        <span [ngClass]="{'active':review.item1 == '002'}" (click)="changeItem('item1','002')">否</span>
                    </div>
                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img1"
                            [(ngModel)]="image1" (change)="imgsChange($event,'img1')">
                        <div class="delete-img" *ngFor="let img of img1;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img1')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img1')"> -->
                    </div>
                    <div class="explain">
                        <em>* 请提供贵中心是三级综合医院，并设有独立设置风湿免疫科的相关资质证明</em>
                        <span>*（如医院官网科室截图、或好大夫在线科室截图等）</span>
                    </div>
                </div>
                <div class="title-3 dFlex">
                    <p class="flex1">组织管理要求（20 分）</p><span>得分{{scoreReview.scoreSum2}}分</span>
                </div>
                <div class="qlist">
                    <p>风湿免疫科中， 主治医师及以上医师占比达到 60%<span>（5分<em
                                class="colorf08200">/得分{{scoreReview.score2}}分</em>）</span><span class="colorRed"
                            (click)="addInfo()" *ngIf="review.item2 == '001'">（ 添加详情 ）</span></p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item2 == '001'}" (click)="changeItem('item2','001')">是</span>
                        <span [ngClass]="{'active':review.item2 == '002'}" (click)="changeItem('item2','002')">否</span>
                    </div>
                    <table class="info" *ngIf="review.item2 == '001'">
                        <tr class="bg">
                            <td>姓名</td>
                            <td>职称</td>
                            <td>是否为国家级学会委员</td>
                            <td>是否为省级学会主委</td>
                            <td>是否为省级学会常委</td>
                            <td>是否为RA专业医师</td>
                            <!-- <td>操作</td> -->
                        </tr>
                        <tr *ngFor="let doctor of doctorList;index as i">
                            <td>{{doctor.item6}}</td>
                            <td>{{doctor.item5}}</td>
                            <td>{{doctor.item1}}</td>
                            <td>{{doctor.item2}}</td>
                            <td>{{doctor.item3}}</td>
                            <td>{{doctor.item4}}</td>
                            <!-- <td>
                                <button class="edit-btn" (click)="editDoctor(doctor,i)">编辑</button>
                                <button class="delete-btn" (click)="deleteDoctor(i)">删除</button>
                            </td> -->
                        </tr>
                    </table>
                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img2"
                            [(ngModel)]="image2" disabled (change)="imgsChange($event,'img2')">

                        <div class="delete-img" *ngFor="let img of img2;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img2')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img2')"> -->
                    </div>
                    <div class="explain">
                        <em>* 请提供贵中心主治医师及以上占比达到60%的证明</em>
                        <span>*（提供科室成员架构展示）</span>
                    </div>
                </div>
                <div class="qlist nodFlex">
                    <div class="dFlex">
                        <p class="flex1">拥有至少一名风湿免疫学术带头人：<span>（5分<em
                                    class="colorf08200">/得分{{scoreReview.score3}}分</em>）</span>
                        </p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item3 == '001'}"
                                (click)="changeItem('item3','001')">是</span>
                            <span [ngClass]="{'active':review.item3 == '002'}"
                                (click)="changeItem('item3','002')">否</span>
                        </div>
                    </div>
                    <div class="dFlex" *ngIf="review.item3 == '001'">
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="radio" name="a" value="001" [(ngModel)]="review.item4"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">国家级学会委员</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="radio" name="a" value="002" [(ngModel)]="review.item4"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">省级学会主委</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="radio" name="a" value="003" [(ngModel)]="review.item4"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">省级学会常委</div>
                            </label>
                        </div>
                    </div>
                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img3"
                            [(ngModel)]="image3" disabled (change)="imgsChange($event,'img3')">
                        <div class="delete-img" *ngFor="let img of img3;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img3')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img3')"> -->
                    </div>
                    <div class="explain">
                        <em>* 拥有至少一名风湿免疫学术带头人</em>
                        <span>*（提供学术带头人简历）</span>
                    </div>
                </div>
                <div class="qlist">
                    <p>风湿免疫科有至少 2 名能进行类风湿关节炎（RA）诊疗与研究的专业医师，具备 RA 规范化诊断和管理能力，有疾病评估团队、包括负责指导患者评估的护士至少1名<span>（5分<em
                                class="colorf08200">/得分{{scoreReview.score4}}分</em>）</span></p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item5 == '001'}" (click)="changeItem('item5','001')">是</span>
                        <span [ngClass]="{'active':review.item5 == '002'}" (click)="changeItem('item5','002')">否</span>
                    </div>
                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img4"
                            [(ngModel)]="image4" disabled (change)="imgsChange($event,'img4')">
                        <div class="delete-img" *ngFor="let img of img4;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img4')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img4')"> -->
                    </div>
                    <div class="explain">
                        <em>* 至少2名RA专业医师</em>
                        <span>*（提供类风湿关节炎诊疗与研究的专业医师简历及介绍）</span>
                    </div>
                </div>
                <div class="qlist">
                    <p>是否有能力开展针对 RA 患者的 MDT 跨学科合作诊疗，MDT 科室资源应包括骨科、放射科、呼吸科、心内科、内分泌科等，能够对 RA
                        器官受累患者进行跨学科诊治、会诊和转诊等<span>（5分<em class="colorf08200">/得分{{scoreReview.score5}}分</em>）</span></p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item6 == '001'}" (click)="changeItem('item6','001')">是</span>
                        <span [ngClass]="{'active':review.item6 == '002'}" (click)="changeItem('item6','002')">否</span>
                    </div>
                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img5"
                            [(ngModel)]="image5" disabled (change)="imgsChange($event,'img5')">
                        <div class="delete-img" *ngFor="let img of img5;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img5')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img5')"> -->
                    </div>
                    <div class="explain">
                        <em>* 有能力开展针对 RA 患者的 MDT 跨学科合作诊疗，MDT 科室资源应包括肾内科、血液科、呼吸科、心内科、神内科、皮肤科等，能够对 RA
                            器官受累患者进行跨学科诊治、会诊和转诊等</em>
                        <span>*（提供医院官网具备其它科室的截图、或好大夫在线截图等）</span>
                    </div>
                </div>
                <div class="title-3 dFlex">
                    <p class="flex1">建设及服务要求（ 35 分）</p><span>得分{{scoreReview.scoreSum3}}分</span>
                </div>
                <div class="qlist nodFlex">
                    <p>使用国家风湿病数据中心（CRDC）作为随访管理平台，建立符合标准的类风湿关节炎患者信息登记和统计随访，常规进行类风湿关节炎患者诊疗、用药情况 登记：<span>（10分<em
                                class="colorf08200">/得分{{scoreReview.score6}}分</em>）</span></p>
                    <div class="dFlex">
                        <label class="radio-button">
                            <input type="radio" name="b" value="001" [(ngModel)]="review.item7"
                                (ngModelChange)="itemChange()" disabled>
                            <span class="custom-radio-button"></span>
                            <div class="label">总计录入 2500 名及以上患者</div>
                        </label>
                    </div>
                    <div class="dFlex">
                        <label class="radio-button">
                            <input type="radio" name="b" value="002" [(ngModel)]="review.item7"
                                (ngModelChange)="itemChange()" disabled>
                            <span class="custom-radio-button"></span>
                            <div class="label">总计录入 2000 名患者</div>
                        </label>
                    </div>
                    <div class="dFlex">
                        <label class="radio-button">
                            <input type="radio" name="b" value="003" [(ngModel)]="review.item7"
                                (ngModelChange)="itemChange()" disabled>
                            <span class="custom-radio-button"></span>
                            <div class="label">总计录入 1500 名患者</div>
                        </label>
                    </div>
                    <div class="dFlex">
                        <label class="radio-button">
                            <input type="radio" name="b" value="004" [(ngModel)]="review.item7"
                                (ngModelChange)="itemChange()" disabled>
                            <span class="custom-radio-button"></span>
                            <div class="label">总计录入 1000 名以下患者</div>
                        </label>
                    </div>
                </div>
                <div class="qlist">
                    <p>能进行炎性指标检查，如红细胞沉降率、 C 反应蛋白、超敏C反应蛋白等<span>（1分<em
                                class="colorf08200">/得分{{scoreReview.score7}}分</em>）</span>
                    </p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item8 == '001'}" (click)="changeItem('item8','001')">是</span>
                        <span [ngClass]="{'active':review.item8 == '002'}" (click)="changeItem('item8','002')">否</span>
                    </div>
                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img6"
                            [(ngModel)]="image6" disabled (change)="imgsChange($event,'img6')">
                        <div class="delete-img" *ngFor="let img of img6;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img6')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img6')"> -->
                    </div>
                    <div class="explain">
                        <em>* 医院是否能够进行炎性指标检查，如红细胞沉降率、 C 反应蛋白、超敏C反应蛋白等</em>
                        <span>*（提供带有本单位抬头的报告单照片）</span>
                    </div>
                </div>
                <div class="qlist">
                    <p>能进行免疫学相关检查，包括：类风湿因子（RF）和 抗瓜氨酸蛋白抗体(ACPA)<span>（5分<em
                                class="colorf08200">/得分{{scoreReview.score8}}分</em>）</span>
                    </p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item9 == '001'}" (click)="changeItem('item9','001')">是</span>
                        <span [ngClass]="{'active':review.item9 == '002'}" (click)="changeItem('item9','002')">否</span>
                    </div>
                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img7"
                            [(ngModel)]="image7" disabled (change)="imgsChange($event,'img7')">
                        <div class="delete-img" *ngFor="let img of img7;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img7')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img7')"> -->
                    </div>
                    <div class="explain">
                        <em>* 医院是否具备免疫学相关检查能力，包括类风湿因子（RF）和 抗瓜氨酸蛋白抗体(ACPA)等</em>
                        <span>*（提供相关检查带有本单位抬头的报告单照片）</span>
                    </div>
                </div>
                <div class="qlist">
                    <p>医院具备关节X线、胸部高分辨CT等影像学检查能力<span>（5分<em class="colorf08200">/得分{{scoreReview.score9}}分</em>）</span>
                    </p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item10 == '001'}"
                            (click)="changeItem('item10','001')">是</span>
                        <span [ngClass]="{'active':review.item10 == '002'}"
                            (click)="changeItem('item10','002')">否</span>
                    </div>
                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img8"
                            [(ngModel)]="image8" disabled (change)="imgsChange($event,'img8')">
                        <div class="delete-img" *ngFor="let img of img8;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img8')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img8')"> -->
                    </div>
                    <div class="explain">
                        <em>* 医院是否具备关节X线、胸部高分辨CT等影像学检查能力</em>
                        <span>*（提供相关影像学检查带有本单位抬头的报告单照片）</span>
                    </div>
                </div>
                <div class="qlist">
                    <p>医院具备关节超声、MRI等影像学检查能力<span>（3分<em class="colorf08200">/得分{{scoreReview.score10}}分</em>）</span></p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item11 == '001'}"
                            (click)="changeItem('item11','001')">是</span>
                        <span [ngClass]="{'active':review.item11 == '002'}"
                            (click)="changeItem('item11','002')">否</span>
                    </div>
                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img9"
                            [(ngModel)]="image9" disabled (change)="imgsChange($event,'img9')">
                        <div class="delete-img" *ngFor="let img of img9;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img9')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img9')"> -->
                    </div>
                    <div class="explain">
                        <em>* 医院是否具备关节超声、MRI等影像学检查的能力</em>
                        <span>*（提供相关检查带有本单位抬头的报告单照片）</span>
                    </div>
                </div>
                <div class="qlist nodFlex">
                    <p class="flex1">能够可及到《中国类风湿关节炎诊断与治疗指南（2024版）》中提到的常规治疗药物 ，以及在中国获批的创新生物制剂：<span>（8分<em
                                class="colorf08200">/得分{{scoreReview.scoreSum6}}分</em>）</span></p>

                    <div class="pl20 dFlex">
                        <p class="flex1">改善病情的抗风湿药<span>（3分<em
                                    class="colorf08200">/得分{{scoreReview.scoreSum4}}分</em>）</span></p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item12 == '001'}"
                                (click)="changeItem('item12','001')">是</span>
                            <span [ngClass]="{'active':review.item12 == '002'}"
                                (click)="changeItem('item12','002')">否</span>
                        </div>
                    </div>

                    <div class="pl40 dFlex" *ngIf="review.item12 == '001'">
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c1" value="001" [(ngModel)]="review.item14" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">甲氨蝶呤</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c2" value="001" [(ngModel)]="review.item15" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">来氟米特</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c3" value="001" [(ngModel)]="review.item16" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">柳氮磺吡啶</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c4" value="001" [(ngModel)]="review.item17" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">羟氯喹</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c5" value="001" [(ngModel)]="review.item18" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">艾拉莫德</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c6" value="001" [(ngModel)]="review.item19" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">雷公藤多苷</div>
                            </label>
                        </div>
                    </div>

                    <div class="pl20 dFlex">
                        <p class="flex1">非甾体类抗炎药<span>（1分<em
                                    class="colorf08200">/得分{{scoreReview.score11}}分</em>）</span></p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item20 == '001'}"
                                (click)="changeItem('item20','001')">是</span>
                            <span [ngClass]="{'active':review.item20 == '002'}"
                                (click)="changeItem('item20','002')">否</span>
                        </div>
                    </div>

                    <div class="pl20 dFlex">
                        <p class="flex1">糖皮质激素<span>（1分<em class="colorf08200">/得分{{scoreReview.score12}}分</em>）</span>
                        </p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item21 == '001'}"
                                (click)="changeItem('item21','001')">是</span>
                            <span [ngClass]="{'active':review.item21 == '002'}"
                                (click)="changeItem('item21','002')">否</span>
                        </div>
                    </div>

                    <div class="pl20 dFlex">
                        <p class="flex1">生物制剂及靶向药物<span>（3分<em
                                    class="colorf08200">/得分{{scoreReview.scoreSum5}}分</em>）</span></p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item22 == '001'}"
                                (click)="changeItem('item22','001')">是</span>
                            <span [ngClass]="{'active':review.item22 == '002'}"
                                (click)="changeItem('item22','002')">否</span>
                        </div>
                    </div>

                    <div class="pl40 dFlex" *ngIf="review.item22 == '001'">
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c1" value="001" [(ngModel)]="review.item23" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">TNF-α抑制剂</div>
                            </label>
                        </div>
                        <!-- <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c2" value="001" [(ngModel)]="review.item24" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">TNF-α受体融合蛋白</div>
                            </label>
                        </div> -->
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c3" value="001" [(ngModel)]="review.item25" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">JAK抑制剂</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="c4" value="001" [(ngModel)]="review.item26" disabled
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">抗人IL-6受体单抗</div>
                            </label>
                        </div>

                    </div>

                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img10"
                            [(ngModel)]="image10" disabled (change)="imgsChange($event,'img10')">
                        <div class="delete-img" *ngFor="let img of img10;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img10')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img10')"> -->
                    </div>
                    <div class="explain">
                        <em>* 能够可及到常规治疗药物及生物制剂</em>
                        <span>*（提供包含本单位抬头的药物的处方截图或医院HIS系统截图）</span>
                    </div>
                </div>


                <div class="qlist">
                    <p>常规组织患者宣教活动并进行随访提醒<span>（3分<em class="colorf08200">/得分{{scoreReview.score13}}分</em>）</span></p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item27 == '001'}"
                            (click)="changeItem('item27','001')">是</span>
                        <span [ngClass]="{'active':review.item27 == '002'}"
                            (click)="changeItem('item27','002')">否</span>
                    </div>
                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img11"
                            [(ngModel)]="image11" disabled (change)="imgsChange($event,'img11')">
                        <div class="delete-img" *ngFor="let img of img11;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img11')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img11')"> -->
                    </div>
                    <div class="explain">
                        <em>* 常规组织患教并进行随访提醒吗</em>
                        <span>*（提供举办患教会的图片，以及随访管理相关佐证）</span>
                    </div>
                </div>
                <div class="title-3 dFlex">
                    <p class="flex1">规范诊疗要 求（40 分）</p><span>得分{{specialScore}}分</span>
                </div>

                <div class="qlist">
                    <p>患者随访率，6个月随访率≥60% <span>（6分<em class="colorf08200">/得分{{specialScore1}}分</em>）</span> <span
                            class="score">
                            {{item1Special}}
                            / {{item1SumSpecial}} = {{rate1}}%</span>
                    </p>
                </div>
                <div class="qlist">
                    <p>患者随访率，12个月随访率≥60% <span>（9分<em class="colorf08200">/得分{{specialScore2}}分</em>）</span><span
                            class="score">
                            {{item2Special}}
                            / {{item2SumSpecial}} = {{rate2}}%</span>
                    </p>
                </div>
                <div class="qlist">
                    <p>患者随访率，≥ 12个月随访率≥30%<span>（10分<em class="colorf08200">/得分{{specialScore3}}分</em>）</span><span
                            class="score">
                            {{item3Special}}
                            / {{item3SumSpecial}} = {{rate3}}%</span></p>
                </div>
                <div class="qlist">
                    <p>每名患者每年至少随访2次的比例达到60%<span>（2分<em class="colorf08200">/得分{{specialScore4}}分</em>）</span><span
                            class="score">
                            {{item4Special}}
                            / {{item3SumSpecial}} = {{rate4}}%</span></p>
                </div>
                <div class="qlist">
                    <p>常规结合 1987年ACR RA分类标准和2010 ACR/EULAR RA分类标准为依据，进行诊断的患者比例达到 95%<span>（2分<em
                                class="colorf08200">/得分{{specialScore5}}分</em>）</span></p>
                </div>
                <div class="qlist">
                    <p>治疗6个月后达到临床缓解标准的患者比例 ≥50%；１年后达到临床缓解标准的患者比例 ≥60%<span>（8分<em
                                class="colorf08200">/得分{{specialScore6}}分</em>）</span>
                        <span class="score"> 六个月：
                            {{item6_5Special}}
                            / {{item1Special}} = {{rate6_1}}%</span> <span class="score"> 一年：
                            {{item6_6Special}}
                            / {{item2Special}} = {{rate6_2}}%</span>
                    </p>
                </div>
                <div class="qlist">
                    <p>筛查评估类风湿关节炎重要合并症和重要器官损害情况的患者比例达到 80%<span>（3分<em
                                class="colorf08200">/得分{{specialScore7}}分</em>）</span><span class="score">
                            {{item7Special}}
                            / {{itemSumSpecial}} = {{rate7}}%</span>
                    </p>
                </div>

                <div class="title-3 mt20 bgnone mb30 textRight">基本项目得分 {{baseScore}} 分</div>
                <div class="title-3 dFlex">
                    <p class="flex1">加分项目（50 分）</p><span>得分{{scoreReview.scoreSum9}}分</span>
                </div>
                <div class="qlist">
                    <p>具备 RA 患者临床生物样本库且正在使用该生物样本库进行患者样本收集<span>（10分<em
                                class="colorf08200">/得分{{scoreReview.score14}}分</em>）</span>
                    </p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item28 == '001'}"
                            (click)="changeItem('item28','001')">是</span>
                        <span [ngClass]="{'active':review.item28 == '002'}"
                            (click)="changeItem('item28','002')">否</span>
                    </div>
                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img12"
                            [(ngModel)]="image12" disabled (change)="imgsChange($event,'img12')">
                        <div class="delete-img" *ngFor="let img of img12;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img12')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img12')"> -->
                    </div>
                    <div class="explain">
                        <em>* 具备RA患者临床生物样本库</em>
                        <span>*（提供相关资质照片）</span>
                    </div>
                </div>
                <div class="qlist">
                    <p>CRDC 自身抗体检测室间质评为“优秀”的单位<span>（5分<em class="colorf08200">/得分{{scoreReview.score15}}分</em>）</span>
                    </p>
                    <div class="segment">
                        <span [ngClass]="{'active':review.item29 == '001'}"
                            (click)="changeItem('item29','001')">是</span>
                        <span [ngClass]="{'active':review.item29 == '002'}"
                            (click)="changeItem('item29','002')">否</span>
                    </div>
                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img13"
                            [(ngModel)]="image13" disabled (change)="imgsChange($event,'img13')">
                        <div class="delete-img" *ngFor="let img of img13;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img13')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img13')"> -->
                    </div>
                    <div class="explain">
                        <em>* CRDC自身抗体检测室质评为“优秀”的单位</em>
                        <span>*（提供相关资质照片）</span>
                    </div>
                </div>
                <div class="qlist nodFlex">
                    <div class="dFlex">
                        <p class="flex1">为地市级及以上临研中心：<span>（5分<em
                                    class="colorf08200">/得分{{scoreReview.score16}}分</em>）</span></p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item30 == '001'}"
                                (click)="changeItem('item30','001')">是</span>
                            <span [ngClass]="{'active':review.item30 == '002'}"
                                (click)="changeItem('item30','002')">否</span>
                        </div>
                    </div>
                    <div class="dFlex" *ngIf="review.item30 == '001'">
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="radio" name="d" value="001" [(ngModel)]="review.item31"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">省级及以上</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="radio" name="d" value="002" [(ngModel)]="review.item31"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">地市级</div>
                            </label>
                        </div>
                    </div>
                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img14"
                            [(ngModel)]="image14" disabled (change)="imgsChange($event,'img14')">
                        <div class="delete-img" *ngFor="let img of img14;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img14')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img14')"> -->
                    </div>
                    <div class="explain">
                        <em>* 为地级市及以上临研中心吗？</em>
                        <span>*（提供相关资质照片）</span>
                    </div>
                </div>
                <div class="qlist nodFlex">
                    <div class="dFlex">
                        <p class="flex1">为地市级及以上质控中心：<span>（5分<em
                                    class="colorf08200">/得分{{scoreReview.score17}}分</em>）</span></p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item33 == '001'}"
                                (click)="changeItem('item33','001')">是</span>
                            <span [ngClass]="{'active':review.item33 == '002'}"
                                (click)="changeItem('item33','002')">否</span>
                        </div>
                    </div>
                    <div class="dFlex" *ngIf="review.item33 == '001'">
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="radio" name="e" value="001" [(ngModel)]="review.item34"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">省级及以上</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="radio" name="e" value="002" [(ngModel)]="review.item34"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">地市级</div>
                            </label>
                        </div>
                    </div>
                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img15"
                            [(ngModel)]="image15" disabled (change)="imgsChange($event,'img15')">
                        <div class="delete-img" *ngFor="let img of img15;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img15')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img15')"> -->
                    </div>
                    <div class="explain">
                        <em>* 为地级市及以上质控中心吗？</em>
                        <span>*（提供相关资质照片）</span>
                    </div>
                </div>
                <div class="qlist nodFlex">
                    <div class="dFlex">
                        <p class="flex1">积极开展类风湿关节炎相关教育培训工作<span>（8分<em
                                    class="colorf08200">/得分{{scoreReview.score18}}分</em>）</span>
                        </p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item35 == '001'}"
                                (click)="changeItem('item35','001')">是</span>
                            <span [ngClass]="{'active':review.item35 == '002'}"
                                (click)="changeItem('item35','002')">否</span>
                        </div>
                    </div>
                    <div *ngIf="review.item35 == '001'">
                        <div class="dFlex">
                            <label class="radio-button">
                                <input type="checkbox" name="f" value="001" [(ngModel)]="review.item36"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">开展国家级风湿免疫病继续医学教育项目</div>
                            </label>
                        </div>
                        <div *ngIf="review.item36 == '001' || review.item36 == '1'">
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item37"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item38"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item39"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                        </div>

                        <div class="dFlex">
                            <label class="radio-button">
                                <input type="checkbox" disabled name="f" value="001" [(ngModel)]="review.item40"
                                    (ngModelChange)="itemChange()">
                                <span class="custom-radio-button"></span>
                                <div class="label">院内设有针对风湿免疫科医师和 MDT 科室医师的类风湿关节炎诊疗常规培训 活动</div>
                            </label>
                        </div>
                    </div>
                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img16"
                            [(ngModel)]="image16" disabled (change)="imgsChange($event,'img16')">
                        <div class="delete-img" *ngFor="let img of img16;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img16')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img16')"> -->
                    </div>
                    <div class="explain">
                        <em>* 积极开展类风湿关节炎相关教育培训工作吗？</em>
                        <span>*（提供相关开展教育培训工作的照片）</span>
                    </div>
                </div>
                <div class="qlist nodFlex">
                    <div class="dFlex">
                        <p class="flex1">带动地市级单位风湿免疫科科室发展和人员培养 <span>（7分<em
                                    class="colorf08200">/得分{{scoreReview.score19}}分</em>）</span>
                        </p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item41 == '001'}"
                                (click)="changeItem('item41','001')">是</span>
                            <span [ngClass]="{'active':review.item41 == '002'}"
                                (click)="changeItem('item41','002')">否</span>
                        </div>
                    </div>

                    <div *ngIf="review.item41 == '001'">
                        <div class="dFlex">
                            <label class="radio-button">
                                <input type="checkbox" name="g" value="001" [(ngModel)]="review.item42"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">到地市医院开展学术会议、教学查房活动</div>
                            </label>
                        </div>
                        <div *ngIf="review.item42 == '001' || review.item42 == '1'">
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item43"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item44"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                        </div>
                        <div class="dFlex">
                            <label class="radio-button">
                                <input type="checkbox" name="g" value="001" [(ngModel)]="review.item45"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">接收地市级以上医院至本院进修</div>
                            </label>
                        </div>
                        <div *ngIf="review.item45 == '001' || review.item45 == '1'">
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item46"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item47"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item48"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                        </div>
                        <div class="dFlex">
                            <label class="radio-button">
                                <input type="checkbox" name="g" value="001" [(ngModel)]="review.item49"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">参与地市级医院的疑难重症病例的远程会诊与讨论</div>
                            </label>
                        </div>
                        <div *ngIf="review.item49 == '001' || review.item49 == '1'">
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item50"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                            <div class="dFlex add-item">
                                <input class="flex1" type="text" placeholder="请输入项目名称" [(ngModel)]="review.item51"
                                    (ngModelChange)="itemChange()" oninput="value=value.replace(/\s+/g,'')" disabled
                                    maxlength="50">
                            </div>
                        </div>
                    </div>

                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img17"
                            [(ngModel)]="image17" disabled (change)="imgsChange($event,'img17')">
                        <div class="delete-img" *ngFor="let img of img17;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img17')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img17')"> -->
                    </div>
                    <div class="explain">
                        <em>* 是否带动地级市单位风湿免疫科科室发展和人员培养</em>
                        <span>*（提供相关开展于地级市相关人员培养活动的照片）</span>
                    </div>
                </div>
                <div class="qlist nodFlex">
                    <div class="dFlex">
                        <p class="flex1">具有良好的科研能力，近3年以第一或通讯作者单位发表（含接收）类风湿关节炎领域原创论文 ，按照当年 JCR 分区评分： <span>（5分<em
                                    class="colorf08200">/得分{{scoreReview.scoreSum7}}分</em>）</span></p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item52 == '001'}"
                                (click)="changeItem('item52','001')">是</span>
                            <span [ngClass]="{'active':review.item52 == '002'}"
                                (click)="changeItem('item52','002')">否</span>
                        </div>
                    </div>
                    <!-- <div *ngIf="review.item52 == '001'">
                        <p>近 3 年以第一或通讯作者单位发表（含接收）类风湿关节炎领域原创论文，按照当年JCR 分区评分：</p>
                    </div> -->
                    <div class="dFlex" *ngIf="review.item52 == '001'">
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="h" value="001" [(ngModel)]="review.item53"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">Q1</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="h" value="001" [(ngModel)]="review.item54"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">Q2</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="h" value="001" [(ngModel)]="review.item55"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">Q3</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="h" value="001" [(ngModel)]="review.item56"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">Q4</div>
                            </label>
                        </div>
                    </div>
                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img18"
                            [(ngModel)]="image18" disabled (change)="imgsChange($event,'img18')">
                        <div class="delete-img" *ngFor="let img of img18;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img18')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img18')"> -->
                    </div>
                    <div class="explain">
                        <em>* 是否具有良好的科研能力</em>
                        <span>*（提供近3年以第一或通讯作者单位发表（含接收）的类风湿关节炎领域原创论文原文或证明邮件）</span>
                    </div>
                </div>
                <div class="qlist nodFlex">
                    <div class="dFlex">
                        <p class="flex1">在 Rheumatology and Immunology Research 期刊上发表（含接收）类风湿关节炎 相关文章：<span>（5分<em
                                    class="colorf08200">/得分{{scoreReview.scoreSum8}}分</em>）</span></p>
                        <div class="segment">
                            <span [ngClass]="{'active':review.item57 == '001'}"
                                (click)="changeItem('item57','001')">是</span>
                            <span [ngClass]="{'active':review.item57 == '002'}"
                                (click)="changeItem('item57','002')">否</span>
                        </div>
                    </div>
                    <div class="dFlex" *ngIf="review.item57 == '001'">
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="i" value="001" [(ngModel)]="review.item58"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">Original article</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="i" value="001" [(ngModel)]="review.item59"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">Review</div>
                            </label>
                        </div>
                        <div class="dFlex mr20">
                            <label class="radio-button">
                                <input type="checkbox" name="i" value="001" [(ngModel)]="review.item60"
                                    (ngModelChange)="itemChange()" disabled>
                                <span class="custom-radio-button"></span>
                                <div class="label">"Letters to the Editor" or "image"</div>
                            </label>
                        </div>
                    </div>
                    <div class="dFlex widthB100">
                        <input accept="image/*" type="file" style="display:none;" value="" id="img19"
                            [(ngModel)]="image19" disabled (change)="imgsChange($event,'img19')">
                        <div class="delete-img" *ngFor="let img of img19;index as i">
                            <img class="up_img" src="{{img.srcThum}}" alt="" (click)="bigImgShow(img.src)">
                            <!-- <span (click)="deleteImage(i,'img19')">X</span> -->
                        </div>
                        <!-- <img class="up_img" src="./assets/up_img.png" alt="" (click)="uploadImg1('img19')"> -->
                    </div>
                    <div class="explain">
                        <em>* 是否在期刊上发表（含接收）类风湿关节炎相关文章</em>
                        <span>*（提供在期刊发表文章的相关证明）</span>
                    </div>
                </div>
                <div class="title-3 mt20 bgnone textRight">您的总得分：{{scoreSum}}分</div>
                <div class="qlist dFlexStart">
                    <div class="dFlex mr20">
                        <label class="radio-button">
                            <input type="radio" name="i" value="002" [(ngModel)]="checkStatus">
                            <span class="custom-radio-button"></span>
                            <div class="label">通过</div>
                        </label>
                    </div>
                    <div class="dFlex">
                        <label class="radio-button">
                            <input type="radio" name="i" value="003" [(ngModel)]="checkStatus">
                            <span class="custom-radio-button"></span>
                            <div class="label">不通过</div>
                        </label>
                    </div>
                </div>
                <button class="submit-btn" (click)="saveCheck()">审核</button>
            </div>
        </div>

    </div>
    <div class="bottom">
        <p>技术支持: 北京风云朗健科技有限公司</p>
        <p>电话:010-67309068 E-mail: service@healthbit.cn</p>
    </div>
</div>

<!-- 放大图片 -->
<div class="big-img" *ngIf="bigImg">
    <div>
        <img src="./assets/ILD_admin_ic_del.png" width="30" height="30" alt="" class="close" (click)="bigImgHide()">
        <img src="{{bigImgSrc}}" alt="" class="up_img">
    </div>
</div>